import { Route, Routes } from "react-router-dom";
import NavBar from "./components/NavBar";
import TopHeader from "./components/TopHeader";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import AirportsEfficiency from "./pages/AirportsEfficiency.js";
import Characteristics from "./pages/Characteristics.js";
//######## DEVELOPMENT TEST##############
import React from "react";
//######################################

function App() {
  return (
    <>
      <TopHeader> </TopHeader>
      <NavBar></NavBar>
      <Routes>
        <Route path="/" element={<Home></Home>}></Route>
        <Route path="/Characteristics" element={<Characteristics />}></Route>
        <Route
          path="/AirportsEfficiency"
          element={<AirportsEfficiency />}
        ></Route>
      </Routes>
      <Footer></Footer>
    </>
  );
}

export default App;
